<template>
    <CChartPie :datasets="defaultDatasets" :labels="labelPayment" />
</template>

<script>
import { CChartPie } from '@coreui/vue-chartjs';
import { mapActions } from "vuex";


export default {
    name: 'CChartPieExample',
    components: { CChartPie },
    data() {
        return {
            prefix: "beads",
            metodsPayments: [],
            ingresosDiarios: [],
            verificBead: false,
            bead: {
                id: ""
            },
            coloresMetodoPago: {
                "efectivo": '#41B883',
                "tarjeta": '#0a4d86',
                "yape": '#8527a4',
                "plin": '#08e1ca',
                "transferencia": '#DD4B18'
            }
        }
    },
    computed: {
        defaultDatasets() {
            return [
                {
                    backgroundColor: this.metodsPayments.map(mp =>
                        this.coloresMetodoPago[mp.method_name.toLowerCase()] || '#e5e5e5'
                    ),
                    data: this.getDailyIncomeValues()
                }
            ]
        },
        labelPayment() {
            return this.metodsPayments.map(mp => mp.method_name);
        }
    },
    created() {
        this.getData();
    },
    methods: {
        ...mapActions(["get", "post"]),
        getData: function () {
            this.get({
                url: this.$store.getters.get__url + "/beads/indexHome/" + this.$store.getters.get_campu.id + "/" + this.$store.getters.get_company.id + "/" + this.$store.getters.get__user_id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode == 200) {
                    this.verificBead = response.data.bead ? true : false;
                    this.metodsPayments = response.data.dailyIncome;
                    // Emit the totals to parent component
                    this.$emit('dailyTotal', response.data.dailyIncomeTotal || 0);
                    this.$emit('dailyPending', response.data.dailyPendingTotal || 0);
                    this.$emit('dailyTotalSold', response.data.dailyTotalSold || 0);
                }
            });
        },
        getDailyIncomeValues() {
            return this.metodsPayments.map(mp => {
                return mp.total;
            });
        }
    }
}
</script>